import request from '@/services/base/request'

export default {
  verifyClientToken: ({ token }: any) => request(`/clients/${token}/login-request/`, 'get', undefined)
} as {[key: string]: MethodDecorator}
